// API configuration
// En Vite, las variables de entorno usan import.meta.env en lugar de process.env
const API_BASE_URL = import.meta.env.VITE_API_URL || (
  // En desarrollo, usar localhost. En producción, usar el dominio de API
  import.meta.env.DEV ? 'http://localhost:8380' : 'https://api.el-impostor.com'
);

export const api = {
  baseURL: API_BASE_URL,
  endpoints: {
    rooms: '/api/rooms',
    games: '/api/games',
    health: '/api/health',
    contacts: '/api/contacts',
    table: '/api/games/table'
  }
};

export default api;
